import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

// Componente genérico de Breadcrumbs
const Breadcrumbs = ({ paths }) => {
  return (
    <Breadcrumb>
      {paths.map((path, index) => (
        <Breadcrumb.Item
          key={index}
          active={index === paths.length - 1}
          linkAs={Link}
          linkProps={{ to: path.url }}
        >
          {path.name}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
